module.exports = __webpack_public_path__ + "img/nolimit-stream.bde22652.svg";